import { render, staticRenderFns } from "./SocialNetworksLegacy.vue?vue&type=template&id=993b09cc&"
import script from "./SocialNetworksLegacy.vue?vue&type=script&lang=js&"
export * from "./SocialNetworksLegacy.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworksLegacy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports